var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent, Fragment } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Loading from "@irati/ui/src/Loading";
import { StyledButton, StyledValidationButton, Flex, StyledIcon } from "./styled";
import { LoadingWrapper } from "../shared";
var ContinueBackButtons = /** @class */ (function (_super) {
    __extends(ContinueBackButtons, _super);
    function ContinueBackButtons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContinueBackButtons.prototype.render = function () {
        var _a = this.props, onBack = _a.onBack, onContinue = _a.onContinue, load = _a.load, formatMessage = _a.formatMessage;
        return (React.createElement(Fragment, null,
            React.createElement(Flex, null,
                React.createElement(StyledButton, { large: true, full: true, onClick: onBack },
                    React.createElement(StyledIcon, { icon: "backArrow" }),
                    React.createElement(FormattedMessage, { id: "medical.global.buttons.back" })),
                React.createElement(StyledValidationButton, { primary: true, large: true, full: true, load: load, loading: formatMessage({ id: "medical.global.buttons.loading" }), onClick: onContinue },
                    React.createElement(FormattedMessage, { id: "medical.global.buttons.continue" }))),
            React.createElement(LoadingWrapper, null,
                React.createElement(Loading, { load: load, useLoader: false }))));
    };
    return ContinueBackButtons;
}(PureComponent));
export default injectIntl(ContinueBackButtons);
